import { ComponentRef, ViewContainerRef } from "@angular/core";
import { PassKeyDeleteFailureComponent } from "./pass-key-delete-failure.component";


class PasskeyDeleteFailureForm implements com.ts.mobile.sdk.UIFormSession{
    clientContext: object;
    actionContext: object;
    formId: string;
    payload: object;

    submitHandler: any;
    submitBlock: (payload: object) => void;
    viewContainerRef: ViewContainerRef;
    passKeyDeleteSuccessComponentRef: ComponentRef<PassKeyDeleteFailureComponent>;

    constructor(formId: string, payload: object) {

        this.formId = formId;
        this.payload = payload;
    }

    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {

        this.clientContext = clientContext;
        this.actionContext = actionContext;
        this.viewContainerRef = (clientContext as any).viewContainerRef;
      }

      endSession(): void {

      }

      promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
        this.viewContainerRef.clear();
        this.passKeyDeleteSuccessComponentRef = this.viewContainerRef.createComponent(PassKeyDeleteFailureComponent);
        this.passKeyDeleteSuccessComponentRef.instance.onCloseLinkSubmit = this.onCloseSubmit.bind(this);

        return new Promise((resolve, reject) => {
          this.submitBlock = (payload: object) => {
            try {
              resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest({}));

              this.submitBlock = null;
            } catch (e) {

              console.error(e);
            }
          };
        });
      }

      onContinue(payload: object): void {

      }

      onError(payload: object): void {

      }

      private onCloseSubmit() {
        this.submitBlock(null);
      }
}

export default PasskeyDeleteFailureForm;
